export default {
    /**
     * @static
     * @type {number}
     * @default 1792
     */
    STAGE_WIDTH: 1792,

    /**
     * @static
     * @type {number}
     * @default 768
     */
    STAGE_HEIGHT: 768,

    /**
     * @static
     * @type {object}
     */
    config: {},

    /**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.Renderer}
     */
    renderer: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    stage: null,

    /**
     * @static
     * @type {P3.Ticker}
     */
    ticker: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    transitions: null,

    /**
     * @static
     * @type {?object}
     */
    strings: null,

    /**
     * @static
     * @type {SaveData}
     */
    saveData: null,

    /**
     * @type {[]}
     */
    characterFiles: null,

    /**
     * @type {[]}
     */
    characters: null,

    /**
     * @type {number}
     */
    ipIndex: 0,

    /**
     * @type {PIXI.Loader}
     */
    tempLoader: null,

    /**
     * @type {[{}]}
     */
    audioFiles: null,

    /**
     * @type {PIXI.Point}
     */
    tilePosition: new PIXI.Point()
}